<h2>Downloading documents</h2>

<div class="dialog-content">

  <!-- Progress bar Aquila -->
  <nx-progressbar
    [value]="data.progress">
  </nx-progressbar>

  <p>
    {{ data.processed }} / {{ data.total }} ({{ data.progress }}%)
  </p>

  <p *ngIf="data.speed">
    Speed: {{ data.speed }} items/sec
  </p>

  <p *ngIf="data.eta">
    Remaining time: ~{{ data.eta }} sec
  </p>

  <div *ngIf="data.failedItems?.length > 0" style="margin-top:15px">
    <h4>Errors ({{ data.failedItems.length }})</h4>

    <ul>
      <li *ngFor="let item of data.failedItems | slice:0:10">
        {{ item }}
      </li>
    </ul>

    <p *ngIf="data.failedItems.length > 10">
      ... more {{ data.failedItems.length - 10 }}
    </p>
  </div>

  <div style="text-align: center; margin-top: 15px;">
    <!-- <button nxButton="primary small"
            type="button"
            (click)="data.cancel()">
      Cancel
    </button> -->
    <button nxButton="primary small"
            type="button"
            (click)="closeDialog()">
      Close
    </button>
    
  </div>

</div>